---@meta

---@class TwitchUser
---@field id string
---@field name string
---@field displayName string
---@field color string
---@field badges table
---@field isBroadcaster boolean
---@field isMod boolean
---@field isVip boolean

---@class PrivateMessage
---@field user TwitchUser
---@field raw string
---@field type number
---@field rawType string
---@field tags table
---@field message string
---@field channel string
---@field roomID string
---@field id string
---@field time string
---@field bits number
---@field action boolean
---@field firstMessage boolean
---@field customRewardID string

---@class ActivityModel
---@field id string
---@field date string
---@field username string
---@field displayname string
---@field usernameOther string
---@field displaynameOther string
---@field type number
---@field metaTitle string
---@field metaCount string

---@class WordObserver
---@field id string
---@field word string
---@field ignoreSpaces boolean

---@class BadWordEventMessage
---@field observer WordObserver
---@field message PrivateMessage

---@class ObservedWordEventMessage
---@field observer WordObserver
---@field message PrivateMessage

---@class EmoteEventMessage
---@field emote string
---@field message PrivateMessage

---@class StreamState
---@field isOnline boolean
---@field categoryId string
---@field categoryName string

---@class WebhookHeader
---@field name string
---@field value string

---@class WebhookReceiverMessage
---@field body string
---@field method string
---@field receiverName string
---@field headers WebhookHeader[]

---@class ChannelInformation
---@field id string
---@field login string
---@field displayName string
---@field language string
---@field gameName string
---@field gameId string
---@field streamTitle string
---@field streamDelay number
---@field streamTags table
